export default "__VITE_ASSET__ba7e3350__"